import { render } from "./CompanyAccount.vue?vue&type=template&id=6d4f1b5e&scoped=true"
import script from "./CompanyAccount.vue?vue&type=script&lang=js"
export * from "./CompanyAccount.vue?vue&type=script&lang=js"

import "./CompanyAccount.vue?vue&type=style&index=0&id=6d4f1b5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d4f1b5e"]])

export default __exports__